import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TOKEN_ID } from '@constants/router.const';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';

/** Http interceptor for authentication */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private cookieService = inject(CookieService);

  intercept(req: HttpRequest<never>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authToken = this.cookieService.get(TOKEN_ID);
    let request: HttpRequest<never> = req.clone();

    if (authToken) {
      request = request.clone({
        setHeaders: {
          Authorization: authToken,
        },
      });
    } else if (request.url.indexOf('assets') === -1) {
      customLogger.warn('[AuthInterceptor] - Following request is without AUTH headers:');
      customLogger.warn(request);
    }

    return next.handle(request);
  }
}
